import script from "./InitProp.vue?vue&type=script&setup=true&lang=ts"
export * from "./InitProp.vue?vue&type=script&setup=true&lang=ts"

import "./InitProp.vue?vue&type=style&index=0&id=cd79936c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd79936c"]])

export default __exports__